import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'
import { useDispatch, useSelector } from 'react-redux'
import { changeObjectPropertyAction, clearAppDataAction } from 'redux/actions'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'

const ScreeningQuestionView = ({ t, i18n }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [errorMsg, setErrorMsg] = useState('')
  const { nsHealthCard, driverLicence, vehiclePermit, registeredByName, jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)

  const handleCheckBox = (e) => {
    let field = e.currentTarget.value;
    dispatch(clearAppDataAction());
    if (field === 'vehiclePermit' && !e.currentTarget.checked) {
      dispatch(changeObjectPropertyAction('addressTypeChange', 'vehiclePermit', false))
      dispatch(changeObjectPropertyAction('addressTypeChange', 'registeredByName', false))
      dispatch(changeObjectPropertyAction('addressTypeChange', 'jointlyRegistered', false))
      dispatch(changeObjectPropertyAction('addressTypeChange', 'registeredBusiness', false))
    }
    else {
      dispatch(changeObjectPropertyAction('addressTypeChange', field, e.currentTarget.checked))
    }

    // if the nested checkbox fields are checked update vehiclePermit
    if (field === 'registeredByName' || field === 'jointlyRegistered' || field === 'registeredBusiness') {
      if (e.currentTarget.checked) {
        dispatch(changeObjectPropertyAction('addressTypeChange', 'vehiclePermit', true))
      }
      else {
        let isVehiclePermit = true;
        switch (field) {
          case 'registeredByName':
            isVehiclePermit = jointlyRegistered || registeredBusiness;
            break;
          case 'jointlyRegistered':
            isVehiclePermit = registeredByName || registeredBusiness;
            break;
          case 'registeredBusiness':
            isVehiclePermit = registeredByName || jointlyRegistered;
            break;
          default:
            break;
        }
        dispatch(changeObjectPropertyAction('addressTypeChange', 'vehiclePermit', isVehiclePermit))
      }
    }
  }

  const onContinueClick = () => {
    if (nsHealthCard || driverLicence || vehiclePermit || registeredByName || jointlyRegistered || registeredBusiness) {
      if (vehiclePermit && (!registeredByName && !jointlyRegistered && !registeredBusiness)) {
        setErrorMsg('address_type_change.vehicle_permit_selected_error');
        return;
      }
      history.push(`/${i18n.language}${t('routes.current_address')}`)
    }
    else {
      setErrorMsg('address_type_change.select_option')
    }
  }
  const helpURL = i18n.language === "en"
    ? "https://support.novascotia.ca/services/address-changes#finding-master-number-permit"
    : "https://support.novascotia.ca/services/address-changes-fr#finding-master-number-permit"

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor backPath='routes.screening_question' />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('address_type_change.i_need_to_change')}</h1>
              <p>{t('address_type_change.select_all_that')}</p>
              <div className='ns-checkboxes__item'>
                <input className="ns-checkboxes__input" type="checkbox" id={t('address_type_change.driver_licence_or')} value="driverLicence" onChange={handleCheckBox}
                  checked={driverLicence} />
                <label className="ns-label ns-checkboxes__label" htmlFor={t('address_type_change.driver_licence_or')} key={t('address_type_change.driver_licence_or')}>
                  <span className="ns-label-span">{t('address_type_change.driver_licence_or')}</span>
                </label>
              </div>
              <div className='ns-checkboxes__item'>
                <input className="ns-checkboxes__input" type="checkbox" id={t('address_type_change.vehicle_permit_or')} value="vehiclePermit" onChange={handleCheckBox}
                  checked={vehiclePermit} />
                <label className="ns-label ns-checkboxes__label" htmlFor={t('address_type_change.vehicle_permit_or')} key={t('address_type_change.vehicle_permit_or')}>
                  <span className="ns-label-span">{t('address_type_change.vehicle_permit_or')}</span>
                </label>
              </div>
              <div className='vehicle-permit-types'>
                <blockquote>
                  <div className='ns-checkboxes__item'>
                    <input className="ns-checkboxes__input" type="checkbox" id={t('address_type_change.registered_in')} value="registeredByName" onChange={handleCheckBox}
                      checked={registeredByName} />
                    <label className="ns-label ns-checkboxes__label" htmlFor={t('address_type_change.registered_in')} key={t('address_type_change.registered_in')}>
                      <span className="ns-label-span">{t('address_type_change.registered_in')}</span>
                    </label>
                  </div>
                  <div className='ns-checkboxes__item'>
                    <input className="ns-checkboxes__input" type="checkbox" id={t('address_type_change.jointly_registered')} value="jointlyRegistered" onChange={handleCheckBox}
                      checked={jointlyRegistered} />
                    <label className="ns-label ns-checkboxes__label" htmlFor={t('address_type_change.jointly_registered')} key={t('address_type_change.jointly_registered')}>
                      <span className="ns-label-span">{t('address_type_change.jointly_registered')}</span>
                    </label>
                  </div>
                  <div className='ns-checkboxes__item'>
                    <input className="ns-checkboxes__input" type="checkbox" id={t('address_type_change.registered_to_business')} value="registeredBusiness" onChange={handleCheckBox}
                      checked={registeredBusiness} />
                    <label className="ns-label ns-checkboxes__label" htmlFor={t('address_type_change.registered_to_business')} key={t('address_type_change.registered_to_business')}>
                      <span className="ns-label-span">{t('address_type_change.registered_to_business')}</span>
                    </label>
                  </div>
                  <br />
                  {/* eslint-disable */}
                  <p>{t('address_type_change.a_unique_master')}<br />{t('address_type_change.you_will_need')}<a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={helpURL}>{t('address_type_change.find_this_master')}</a></p>
                </blockquote>
              </div>
            </div>
          </div>
          <ContinueCancelButtons continueClick={onContinueClick} errorText={errorMsg} />
        </article>
      </main >
    </div >
  )
}

export default withTranslation('common')(ScreeningQuestionView)
